<script>
	import model from "../../stores/modelStore";
	import { projectSettings } from "../../config";
	import { registerFormStart } from "../../tealium";

	import PageSection from "../../components/PageSection.svelte";
	import Form from "../../components/Form.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";
	import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";
	import Checkbox from "../../components/Checkbox.svelte";

	export let pageTitle = null;
	export let lastVisitedPage = null;
	export let disabled = null;

	let buttons;

	if (!disabled) {
		$model.LastPageVisited = lastVisitedPage;
		document.title = pageTitle;

		//  Get the user Agent
		$model.UserAgent = navigator.userAgent;
		$model.referrer = document.referrer;
		$model.RegistrationSegmentId = null;
	}

	const handleSubmit = async (e) => {
		buttons.blockNext();

		e.preventDefault();

		await registerFormStart();

		buttons.next();
		buttons.unblock();
		return true;

		//TODO: Uncomment this code when the reCaptcha is ready
		grecaptcha.ready(function () {
			grecaptcha.execute(projectSettings.gSiteKey3, { action: "submit" }).then(async function (token) {
				let options = {
					method: "POST",
					headers: {
						"Content-type": "application/json"
					},
					body: JSON.stringify({ token: token })
				};

				var url = "/api/gverify";
				let response = await fetch(`${url}`, options);
				if (response.ok) {
					let data = await response.json();

					if (data && data.status === true) {
						await registerFormStart();

						buttons.next();
						buttons.unblock();
						return true;
					}

					grecaptcha.render(document.getElementById("g-recaptcha"), {
						sitekey: projectSettings.gSiteKey2,
						callback: reCaptchaV2
					});
				}

				return false;
			});
		});
	};

	const reCaptchaV2 = async (token) => {
		let options = {
			method: "POST",
			headers: {
				"Content-type": "application/json"
			},
			body: JSON.stringify({ token: token })
		};

		let url = "/api/gverifyv2";
		let response = await fetch(`${url}`, options);
		let data = await response.json();

		if (data.status) {
			await registerFormStart();

			buttons.next();
			buttons.unblock();
		}
	};
</script>

<PageSection>
	<Form id="form-landing-page" on:submit={handleSubmit}>
		<FormRow class="justify-content-center confirmation-hide">
			<FormColumn>
				<h1 class="text-center">Register for the South Australia Sunday Shift Class Actions</h1>
			</FormColumn>
		</FormRow>

		<hr class="confirmation-hide" />
		<FormRow class="justify-content-md-center confirmation-hide">
			<FormColumn>
				<p>
					You can register for the South Australia Sunday Shift Class Actions if you worked <b
						>at least one Sunday shift in South Australia</b> during the following periods:
				</p>
				<ul>
					<li>Between 17 November 2019 to 31 December 2023 at:</li>
					<ul style="margin-top: 10px;">
						<li>McDonald's</li>
					</ul>
					<li>Between 4 December 2019 to 31 December 2023 at:</li>
					<ul style="margin-top: 10px;">
						<li>Big W</li>
						<li>Woolworths Supermarkets</li>
					</ul>
					<li>Between 15 December 2019 to 31 December 2023 at:</li>
					<ul style="margin-top: 10px;">
						<li>Hungry Jack's</li>
					</ul>
					<li>Between 23 December 2019 to 31 December 2023 at:</li>
					<ul style="margin-top: 10px;">
						<li>Coles Supermarkets</li>
					</ul>
				</ul>
				<p>
					To register on a confidential, no-cost, no-obligation basis, please complete the following
					registration form.
				</p>
				<p>
					<b>Please note:</b> You only need to register <b>once</b>, even if you worked for more than one of
					these employers during the relevant period.
				</p>
			</FormColumn>
		</FormRow>

		<hr />

		<FormRow class="confirmation-box-shadow">
			<FormColumn>
				<!-- svelte-ignore a11y-label-has-associated-control -->
				<label class="mb-3">
					Do you agree to provide us with personal information which will be kept confidential under the Shine
					Lawyers
					<a href="https://www.shine.com.au/privacy-policy" title="Privacy Policy" target="_blank"
						>Privacy Policy</a
					>?
				</label>
				<div class="">
					<Checkbox
						required="true"
						{disabled}
						bind:checked={$model.privacyPolicyConfirmed}
						label="I agree to the privacy policy"
						id="privacy"></Checkbox>
				</div>
			</FormColumn>
		</FormRow>

		<FormRow class="confirmation-box-shadow">
			<FormColumn>
				<label class="mb-3" for="dataConsent"
					>Do you consent to the data provided in this form being shared with Retail and Fast Food Workers
					Union (RAFFWU)</label>
				<div class="">
					<Checkbox
						required="true"
						name="dataConsent"
						{disabled}
						bind:checked={$model.shareWithRAFFWU}
						label="I consent"
						id="dataconsent"></Checkbox>
				</div>
			</FormColumn>
		</FormRow>

		<FormRow class="justify-content-md-center register-btn confirmation-hide">
			<FormColumn class="text-center" cols="12">
				<NavigationButtons
					showPrevious={false}
					bind:buttons
					nextPageLabel="REGISTER FOR THE CLASS ACTION"
					disableNext={!$model.privacyPolicyConfirmed || !$model.shareWithRAFFWU}></NavigationButtons>
			</FormColumn>
			<FormColumn cols="12">
				<div class="recaptcha">
					<div id="g-recaptcha" data-sitekey={projectSettings.gSiteKey2}></div>
				</div>
			</FormColumn>
		</FormRow>

		<FormRow class="justify-content-md-center confirmation-hide">
			<FormColumn>
				<p>
					If you require support completing your registration, please contact Shine Lawyers on
					<ClassActionPhoneNumber></ClassActionPhoneNumber> or email
					<ClassActionEmailAddress></ClassActionEmailAddress>.
				</p>
			</FormColumn>
		</FormRow>
	</Form>
</PageSection>

<style>
	h1 {
		margin-bottom: 20px;
	}

	.recaptcha {
		padding-top: 20px;
		display: flex;
		justify-content: center;
	}

	.unbold {
		font-weight: normal;
	}

	ul {
		padding-left: 40px;
	}

	.landingPageCheckbox {
		background-color: white;
		/* border: 1.5px solid #8a8a8a; */
		box-shadow: 0 0 0 1.5px #8a8a8a;
		/* border: 2px solid rgba(138, 138, 138, 0.5); */
		padding: 15px 14px;
	}

	@media (min-width: 1200px) {
		.landingPageCheckbox {
			width: 60%;
		}
	}

	@media (min-width: 630px) and (max-width: 767px) {
		.landingPageCheckbox {
			width: 60%;
		}
	}
</style>
